import { IS_PLACES_VISITED } from '../constants/action-types';

export const isPlacesVisited = (isPlacesVisited = false) => ({
    type: IS_PLACES_VISITED,
    isPlacesVisited
});